export default "__VITE_ASSET__Cu14Kyu6__"